var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useReducer } from 'react';
import { GUIDE_NAMES, Marginer, SettingTemplate, AntdForm, useEntireLoader, StyledFormItem, NumberFormatInput, TextComponent, AntButton, FloatingButtonGroup, checkPermissionForOnClick, AntModalFunc, AntNotification } from 'renderer/components';
import Form from 'antd/lib/form';
import { StoreQuery, TicketQuery } from 'renderer/queries';
import notification from 'antd/lib/notification';
import Switch from 'antd/lib/switch';
import { InlineFormItem } from './templateFields';
import { REGEX_NUMBER_FORMMATER } from 'renderer/constants';
import Select from 'antd/lib/select';
import { COLORS } from 'renderer/styles';
import { isEqual, pick } from 'renderer/utils';
export var CustomerPointSetting = function (_a) {
    var _b, _c, _d;
    var store = _a.store, permission = _a.permission;
    var customerPointPolicy = (_b = store === null || store === void 0 ? void 0 : store.preference) === null || _b === void 0 ? void 0 : _b.customerPointPolicy;
    var hasUpdatePerm = permission === null || permission === void 0 ? void 0 : permission.update;
    var form = Form.useForm()[0];
    var _e = useState(!customerPointPolicy), isChanged = _e[0], setIsChanged = _e[1];
    var _f = useState(''), error = _f[0], setError = _f[1];
    var _g = useState(''), batchError = _g[0], setBatchError = _g[1];
    var loader = useEntireLoader();
    var updateStore = StoreQuery.useUpdateStore();
    var updateExpiration = TicketQuery.useBulkUpdatePointHistoryExpiration();
    var initialValues = {
        isLimit: (customerPointPolicy === null || customerPointPolicy === void 0 ? void 0 : customerPointPolicy.expiredOption) !== null,
        amount: ((_c = customerPointPolicy === null || customerPointPolicy === void 0 ? void 0 : customerPointPolicy.expiredOption) === null || _c === void 0 ? void 0 : _c.amount) || 1,
        unit: ((_d = customerPointPolicy === null || customerPointPolicy === void 0 ? void 0 : customerPointPolicy.expiredOption) === null || _d === void 0 ? void 0 : _d.unit) || 'year',
        batchAmount: 1,
        batchUnit: 'month',
    };
    var _h = useState(initialValues.isLimit), isLimit = _h[0], setIsLimit = _h[1];
    var amountValidator = function (value, unit) {
        if (!value) {
            return '기간을 입력해주세요.';
        }
        var currentDate = new Date();
        var futureDate = new Date(currentDate);
        var maxDate = new Date();
        switch (unit) {
            case 'year':
                futureDate.setFullYear(currentDate.getFullYear() + value);
                break;
            case 'month':
                futureDate.setMonth(currentDate.getMonth() + value);
                break;
            case 'week':
                futureDate.setDate(currentDate.getDate() + value * 7);
                break;
            case 'day':
                futureDate.setDate(currentDate.getDate() + value);
                break;
            default:
                break;
        }
        maxDate.setFullYear(currentDate.getFullYear() + 999);
        if (futureDate > maxDate) {
            return '설정 가능한 기간 범위를 초과했습니다.';
        }
    };
    var handleError = function (error, method) {
        if (error) {
            method(error);
            return Promise.reject(new Error());
        }
        method('');
        return Promise.resolve();
    };
    var _j = useReducer(function (state, newState) { return (__assign(__assign({}, state), newState)); }, {
        amount: initialValues.batchAmount,
        unit: initialValues.batchUnit
    }), batchValue = _j[0], setBatchValue = _j[1];
    var handleClickBatch = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (checkPermissionForOnClick(hasUpdatePerm, '고객정보 수정 권한이 없습니다.')) {
                AntModalFunc({
                    type: 'confirm',
                    zIndex: 9999,
                    title: '고객포인트 일괄 연장',
                    icon: null,
                    content: '현재 고객들에게 설정된 포인트 유효기간을 일괄 연장합니다. (단 잔액이 없거나 이미 만료된 포인트는 적용되지 않습니다)',
                    okText: '일괄 연장',
                    onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, updateExpiration.mutateAsync({
                                            storeId: store.id,
                                            expiredOption: batchValue.unit === 'unlimited' ? null : batchValue
                                        })];
                                case 1:
                                    _a.sent();
                                    AntNotification.success({ message: '고객포인트 일괄 연장 성공' });
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _a.sent();
                                    AntNotification.error({ message: err_1.message });
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                    okButtonProps: {
                        danger: true,
                        type: 'primary'
                    },
                    cancelText: '취소'
                });
            }
            return [2 /*return*/];
        });
    }); };
    var fields = [
        {
            element: (React.createElement(StyledFormItem, { name: "isLimit", label: "\uC720\uD6A8\uAE30\uAC04" },
                React.createElement(Switch, { checked: isLimit, onChange: function (value) { return setIsLimit(value); } })))
        },
        isLimit && {
            element: (React.createElement(React.Fragment, null,
                React.createElement(InlineFormItem, { items: [
                        {
                            name: ['amount'],
                            rules: [{ validator: function (_, value) { return handleError(amountValidator(value, form.getFieldValue(['unit'])), setError); } }],
                            input: (React.createElement(NumberFormatInput, { style: { width: 110 }, placeholder: '기간을 입력해주세요.', formatter: function (value) { return "".concat(value).replace(REGEX_NUMBER_FORMMATER, ','); }, maxLength: 7 }))
                        },
                        {
                            name: ['unit'],
                            rules: [{ validator: function (_, value) { return handleError(amountValidator(form.getFieldValue(['amount']), value), setError); } }],
                            input: (React.createElement(Select, { style: { width: 110 }, options: [
                                    { label: '개월', value: 'month' },
                                    { label: '주', value: 'week' },
                                    { label: '일', value: 'day' },
                                    { label: '년', value: 'year' }
                                ], placeholder: '단위를 입력해주세요.' }))
                        }
                    ], span: "none" }),
                React.createElement(TextComponent, { type: "caption1", color: error ? COLORS.danger : COLORS.gray3 }, error || '포인트 적립시 적용될 유효기간 설정합니다.'),
                React.createElement("div", { style: { height: '24px' } })))
        },
        {
            element: (React.createElement(StyledFormItem, { label: "\uD3EC\uC778\uD2B8 \uC720\uD6A8\uAE30\uAC04 \uC77C\uAD04 \uC5F0\uC7A5" },
                React.createElement(InlineFormItem, { items: [
                        {
                            name: ['batchAmount'],
                            rules: [{ validator: function (_, value) { return handleError(amountValidator(value, form.getFieldValue(['batchUnit'])), setBatchError); } }],
                            input: (React.createElement(NumberFormatInput, { style: { width: 110 }, placeholder: '기간을 입력해주세요.', formatter: function (value) { return "".concat(value).replace(REGEX_NUMBER_FORMMATER, ','); }, onChange: function (value) { return setBatchValue({ amount: value }); }, maxLength: 7, disabled: batchValue.unit === 'unlimited' }))
                        },
                        {
                            name: ['batchUnit'],
                            rules: [{ validator: function (_, value) { return handleError(amountValidator(form.getFieldValue(['batchAmount']), value), setBatchError); } }],
                            input: (React.createElement(Select, { style: { width: 110 }, options: [
                                    { label: '개월', value: 'month' },
                                    { label: '주', value: 'week' },
                                    { label: '일', value: 'day' },
                                    { label: '년', value: 'year' },
                                    { label: '무제한', value: 'unlimited' }
                                ], placeholder: '단위를 입력해주세요.', onChange: function (value) { return setBatchValue({ unit: value }); } }))
                        },
                        {
                            name: ['batchButton'],
                            rules: [],
                            input: (React.createElement(AntButton, { disabled: !!batchError, onClick: handleClickBatch }, "\uC77C\uAD04 \uC801\uC6A9"))
                        }
                    ], span: "none" }),
                React.createElement(TextComponent, { type: "caption1", color: batchError ? COLORS.danger : COLORS.gray3 }, batchError || '연장하실 포인트 유효기간을 선택후 일괄연장을 누르면 전체고객의 포인트 유효기간이 일괄 연장됩니다.')))
        }
    ].filter(Boolean);
    var handleReset = function () {
        setIsLimit(initialValues.isLimit);
        setError('');
        form.resetFields(['amount', 'unit']);
        if (customerPointPolicy) {
            setIsChanged(false);
        }
    };
    var handleSubmit = function (_a) {
        var amount = _a.amount, unit = _a.unit;
        return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!hasUpdatePerm) {
                            notification.info({ message: '수정 권한이 없습니다.' });
                            return [2 /*return*/];
                        }
                        loader.show();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateStore.mutateAsync({
                                id: store.id,
                                preference: __assign(__assign({}, store.preference), { customerPointPolicy: {
                                        expiredOption: isLimit ? {
                                            amount: amount,
                                            unit: unit
                                        } : null
                                    } })
                            })];
                    case 2:
                        _b.sent();
                        notification.success({ message: '고객 포인트 설정이 변경되었습니다.' });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        notification.error({ message: error_1.message || '고객 포인트 설정 변경 중 오류가 발생했습니다.' });
                        return [3 /*break*/, 5];
                    case 4:
                        loader.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        handleReset();
    }, [store]);
    return (React.createElement(SettingTemplate, { title: "\uACE0\uAC1D \uD3EC\uC778\uD2B8 \uC124\uC815", guideName: GUIDE_NAMES.고객포인트설정, description: "\uACE0\uAC1D \uD3EC\uC778\uD2B8 \uC801\uB9BD\uC2DC \uC0AC\uC6A9 \uD560 \uC720\uD6A8\uAE30\uAC04\uC744 \uC124\uC815\uD574\uBCF4\uC138\uC694.", body: React.createElement("div", null,
            React.createElement(Marginer, { height: 4 }),
            React.createElement(AntdForm, { formProps: {
                    layout: 'vertical',
                    form: form,
                    initialValues: initialValues,
                    onFinish: handleSubmit,
                    onValuesChange: function (_, values) {
                        setIsChanged(!customerPointPolicy ||
                            (!isEqual(pick(initialValues, ['isLimit', 'amount', 'unit']), pick(values, ['isLimit', 'amount', 'unit'])) &&
                                form.isFieldsTouched(['isLimit', 'amount', 'unit'])));
                    }
                }, onSubmit: handleSubmit, fields: fields }),
            React.createElement(FloatingButtonGroup, { visible: isChanged, confirmButtonProps: { onClick: form.submit, disabled: !!error }, cancelButtonProps: { onClick: handleReset } })) }));
};
